/*@ngInject*/
const ErrorModalController = function ($rootScope, $scope, options, coreConstant, $uibModalInstance) {

    $scope.viewModel = {
        showTraceMessage: false,
        trace: options.trace,
        okButtonLabel: options.okButtonLabel,
        identifier: options.identifier,
        reference: options.reference,
        message: options.message,
        title: options.title,
        okButtonClass: _.isNil(options.okButtonLabel) ? 'hideOkButton' : null
    };

    $scope.closePopUp = function () {
        $uibModalInstance.close();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('errorModalController', ErrorModalController);
